import getReactDisplayName from 'react-display-name';

// create displayName function for a component (WrappedComponent) which is wrapped
// by a HOC.
// hocType can be either a string (such as 'div') or a React Component
export var hocDisplayName = function hocDisplayName(hocType) {
  return function (WrappedComponent) {
    return hocType + '(' + getReactDisplayName(WrappedComponent) + ')';
  };
};

// Add displayName to a Component
// In addition adds setDisplayName function for setting proper display after HOC is created.
export var addDisplayName = function addDisplayName(HOC, WrappedComponent, getDisplayName) {
  HOC.displayName = getDisplayName(WrappedComponent);
  HOC.setDisplayName = function (displayName) {
    HOC.displayName = getDisplayName(displayName);
  };

  return HOC;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/cf-component-request-status-indicator/node_modules/@cloudflare/style-container/es/displayName.js
// module id = 116
// module chunks = 1